// Şubeler sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'branches.list';

export const branchesListGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Şubeler nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'İşletmenizin şubelerini buradan eklersiniz, düzenlersiniz ve şubelere yönetici atarsınız. Çok sayıda şubeyi Excel dosyasıyla tek seferde ekleyebilirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    filters: t(`${G}.regions.filters`, 'Şube ve statü filtresi'),
    toolbar: t(`${G}.regions.toolbar`, 'Excel İndir, Yeni Şube Ekle'),
    table: t(`${G}.regions.table`, 'Şube listesi ve ⋮ menüsü'),
  },
  steps: [
    {
      region: 'toolbar',
      title: t(`${G}.s1.title`, '1. Yeni şube ekleyin'),
      text: t(`${G}.s1.text`, '"Yeni Şube Ekle" düğmesi şube formunu açar. Şube Adı, Adres ve Telefon Numarası zorunludur; boş bırakılırsa kayıt yapılmaz. Açılış Tarihi, İlçe, Şehir/İl, Posta Kodu, Ülke, E-posta Adresi, Çalışma Saati (veya 7/24 Açık) ve Web Sitesi isteğe bağlıdır.'),
      tips: [
        t(`${G}.s1.tip1`, '"Franchise Şube" anahtarı şubeyi Franchise olarak işaretler; listede Statü sütununda "Franchise" yazar.'),
        t(`${G}.s1.tip2`, 'Mobilde aynı düğme başlığın yanında "Yeni Şube" adıyla görünür.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Excel ile toplu şube ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni Şube Ekle" penceresindeki "Toplu Ekle" düğmesi Toplu Şube Ekleme penceresini açar. Önce "Template İndir" ile şablonu indirin, şubeleri şablona yazın, "Excel Dosyası Seç" ile dosyayı seçip "Yüklemeyi Başlat"a basın. İşlem bitene kadar pencereyi kapatmayın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Şube Adı, Adres ve Telefon alanları zorunludur.'),
        t(`${G}.s2.tip2`, 'Verileri şablonun ilk sayfasına ("Şubeler") girin; örnek satırlar "Örnek" sayfasındadır. Şablondaki örnek şubeler yüklenmez.'),
        t(`${G}.s2.tip3`, 'Açılış tarihi YYYY-MM-DD formatında olmalıdır (örn: 2025-01-15).'),
        t(`${G}.s2.tip4`, 'Franchise kolonu için E (evet) veya H (hayır) yazın.'),
        t(`${G}.s2.tip5`, 'Tek seferde en fazla 100 şube eklenebilir.'),
        t(`${G}.s2.tip6`, 'Dosya .xlsx biçiminde ve 5MB\'dan küçük olmalıdır. Eski .xls dosyasını Excel\'de "Farklı Kaydet" ile .xlsx olarak kaydedin.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Yükleme sonucunu okuyun'),
      text: t(`${G}.s3.text`, 'Yükleme bitince İşlem Sonuçları ekranı Toplam, Başarılı ve Başarısız sayılarını, altında her satırın durumunu ve mesajını gösterir. Başarılı eklenen şubeler hemen listeye eklenir; hatalı satırlar eklenmez, düzeltip yalnız onları yeniden yükleyebilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Listede zaten aynı adda bir şube varsa o satır "Bu isimde bir şube zaten mevcut" hatasıyla atlanır.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s4.title`, '4. Şubeyi bulun, listeyi indirin'),
      text: t(`${G}.s4.text`, '"Şube Filtrele" ile tek bir şubeyi, "Statü Filtrele" ile yalnız Şube veya yalnız Franchise kayıtlarını gösterirsiniz. "Excel İndir" tüm şubeleri (filtreden bağımsız, alfabetik sırayla) Excel dosyasına aktarır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Adres sütunundaki kopyala simgesi şube adresini panoya kopyalar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Satırdaki ⋮ menüsü: firma bilgileri, düzenle, QR, sil'),
      text: t(`${G}.s5.text`, 'Firma Bilgileri: şubenin unvan, vergi ve sicil bilgilerini girersiniz; unvan veya vergi no girilmişse "Firma Bilgileri" sütununda yeşil onay işareti görünür. Düzenle: şube formunu açar, "Güncelle" ile kaydedersiniz. QR Kodu: şube sistemine erişim QR kodunu indirir, yazdırır veya paylaşırsınız.'),
      tips: [
        t(`${G}.s5.tip1`, 'Sil: önce şubenin sistemde (kasa, personel, satış ekranı, fatura vb.) kullanılıp kullanılmadığı denetlenir. Kullanılıyorsa silinemez; listelenen kayıtlardan şubeyi kaldırıp "Yeniden Denetle" deyin.'),
        t(`${G}.s5.tip2`, 'Silme kalıcıdır ve geri alınamaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Şubeye yönetici atayın'),
      text: t(`${G}.s6.text`, '⋮ menüsündeki "Yönetici Ata" personel listesini açar; bir veya birkaç kişiyi seçip kaydedin. Henüz yönetici olmayan personel bu şubenin yöneticisi olur ve ana şubesi bu şube yapılır. Başka bir şubenin yöneticisi olan personel ise bu şubeye ek şube olarak atanır; kendi şubesi değişmez.'),
      tips: [
        t(`${G}.s6.tip1`, '"Yöneticiler" şubenin mevcut yöneticilerini listeler. Sil simgesi kişiyi bu şubenin yöneticiliğinden çıkarır; bu şube kişinin ana şubesiyse yönetici rolü de kaldırılır ve kişi normal personel olur.'),
        t(`${G}.s6.tip2`, '"Yönetici İzinleri" yöneticinin bu şubede hangi modüllere erişebileceğini belirler.'),
      ],
    },
  ],
});
